export interface ApiResponse<T> {
  code: number;
  message: string;
  result: T;
}

export const ServiceCategory = {
  DISPATCH: "DISPATCH",
  FREIGHT_OWNER: "FREIGHT_OWNER",
  PARTNER: "PARTNER",
  ADMIN: "ADMIN",
} as const;
export type ServiceCategoryType =
  (typeof ServiceCategory)[keyof typeof ServiceCategory];

export const SERVICE_CATEGORY_LABEL: Record<ServiceCategoryType, string> = {
  DISPATCH: "배차",
  FREIGHT_OWNER: "화주",
  PARTNER: "파트너",
  ADMIN: "관리자",
};

export const SERVICE_CATEGORY_BADGE: Record<ServiceCategoryType, string> = {
  DISPATCH: "bg-blue-100 text-blue-700",
  FREIGHT_OWNER: "bg-amber-100 text-amber-700",
  PARTNER: "bg-purple-100 text-purple-700",
  ADMIN: "bg-slate-100 text-slate-700",
};

export interface Permission {
  guid: string;
  code: string;
  label: string;
  description: string;
  permissionGroup: string;
  isActive: boolean;
}

export interface UpsertPermissionRequest {
  code: string;
  label: string;
  description?: string;
  permissionGroup: string;
}

export interface TogglePermissionRequest {
  code: string;
  isActive: boolean;
}

// --- 계정 개인 권한 (직접 부여) ---
// API 응답: camelCase / 요청 Body: PascalCase

export interface AccountPermissionMapping {
  accountGuid: string;
  permissionGuid: string;
  permissionCode: string;
  permissionLabel: string;
  permissionGroup: string;
  grantedByAccountGuid: string | null;
  memo: string | null;
  registDate: string | null;
}

export interface GrantAccountPermissionRequest {
  AccountGuid: string;
  PermissionGuid: string;
  Memo?: string;
  GrantedByAccountGuid: string | null;
}

export interface RevokeAccountPermissionRequest {
  AccountGuid: string;
  PermissionGuid: string;
}
